import request from "@/utils/request";

// 判断是否第一次打开
export function revisionVerification(params) {
  return request({
    url: "/yozoOffice/revisionVerification.do",
    method: "post",
    params
  });
}

// 检测文书是否有印
export function decide(data) {
  return request({
    url: "/yozoOffice/decide",
    method: "post",
    data
  });
}

// 导出excle（未完成）
export function exportExcelUnfinish(data) {
  return request({
    url: "excel/uncompletedCondition/exportExcel.do",
    method: "post",
    loading: true,
    data
  });
}

// 导出excle（挽回资金情况）
export function exportExcelMoney(data) {
  return request({
    url: "excel/uncompletedCondition/whzjqkExcel.do",
    method: "post",
    loading: true,
    data
  });
}

// 导出excle（建章立制）
export function exportExcelEstablish(data) {
  return request({
    url: "excel/uncompletedCondition/jzExcel.do",
    method: "post",
    loading: true,
    data
  });
}

// 导出excle（整改分类成效）
export function exportExcelRectifyType(data) {
  return request({
    url: "excel/uncompletedCondition/zgwtflcxExcel.do",
    method: "post",
    loading: true,
    data
  });
}

// 导出excle（整改分类成效总表）
export function exportExcelRectify(data) {
  return request({
    url: "excel/uncompletedCondition/zgcxzbExcel.do",
    method: "post",
    loading: true,
    data
  });
}
// 导出excle（问题类型统计分析）
export function exportExcelMaintain(data) {
  return request({
    url: "excel/uncompletedCondition/zhfxExcel.do",
    method: "post",
    loading: true,
    data
  });
}




// WEBPACK FOOTER //
// ./src/api/yozoOffice.js